module.exports = __webpack_public_path__ + "static/media/knob_small_strip.97805181.png";